export { ModalBackdropComponent, ModalBackdropOptions } from './modal-backdrop.component';
export { ModalDirective } from './modal.component';
export { ModalModule } from './modal.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/modal/index.js
// module id = 520
// module chunks = 3